import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild, ChangeDetectorRef  } from '@angular/core';
import { NgStyle, NgClass, NgIf, NgFor } from '@angular/common';

@Component({
    selector: 'app-score-dropdown-menu',
    templateUrl: './score-dropdown-menu.component.html',
    styleUrls: ['./score-dropdown-menu.component.scss'],
    imports: [
        NgStyle,
        NgClass,
        NgIf,
        NgFor,
    ]
})
export class ScoreDropdownMenuComponent implements OnChanges {
  @ViewChild('dropdownContainer') dropdownContainer!: ElementRef;
  isDropdownOpen: boolean = false;
  @Input() config: any = {};
  @Input() selectedOption: string = '';
  @Input() options: any = [];
  @Output() selectedOptionChange = new EventEmitter<string>();
  selectedField: any = '';
  rawSelectedName: string = '';
  selectedFieldId: string = '';

  constructor(private cdRef: ChangeDetectorRef) {}

  ngOnChanges(changes: SimpleChanges) {
    if(this.config.tab === 'scoreViewtype' && this.options) {
      // Only set to first option if no selectedOption is provided
      if (!this.selectedOption) {
        this.selectedOption = this.options[0]?.labelShort ?? this.options[0]?.name;
        this.rawSelectedName = this.options[0]?.name;
      }
    }
    if(this.options && this.options.length > 0 && this.options[0]?.field_id) {
      const match = this.options.find(
        (item) => item.name === this.selectedOption || item.labelShort === this.selectedOption
      );
      this.selectedField = match?.field_id;
      if (this.config?.tab === 'trends-summary-question' && match?.name) {
        this.rawSelectedName = match.name;
      }
    }
    if(this.config.tab == 'quick-insights') {
      // if hierarchy stack updated, reset selected field_id for dropdown selection 
      if(this.config && this.config.isHierarchyModified) {
        this.selectedFieldId = '';
      }
      if(this.selectedFieldId == '') {
        this.selectedField = this.options.filter(item => item.isDefaultSelected === true)[0]?.field_id;
      }else {
        this.selectedField = this.selectedFieldId;
      }
    }
  }
  
  onButtonClick(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
    if (this.isDropdownOpen) {
      document.addEventListener('click', this.handleClickOutside);
    } else {
      document.removeEventListener('click', this.handleClickOutside);
    }
  }

  onOptionClick(event: any): void {
    if (event?.disabled) {
      return;
    }
    if(this.selectedField === event?.field_id) {
      return;
    }
    this.isDropdownOpen = false;

    if (event?.field_id === 'primary_rating' && event?.isPrefix) {
      this.selectedOption = '<span><b>Primary question • </b></span>'  + (event.labelShort ?? event.name);
    } else if (event?.field_id === 'comments' && event?.isPrefix) {
      this.selectedOption = '<span><b>Primary comment • </b></span>' + (event.labelShort ?? event.name);
    } else {
      if(event.preffix) {
        this.selectedOption = this.getPrefix(event.preffix) + (event.labelShort ?? event.name);
        this.selectedFieldId = event.field_id;
      }else {
        this.selectedOption = event.labelShort ?? event.name;
      }
      this.cdRef.detectChanges();
    }

    let textOutsideSpan = this.selectedOption.replace(/<span.*?>.*?<\/span>/g, '');
    if(this.options && this.options.length > 0 && this.options[0]?.field_id) {
      if (event?.field_id) {
        this.selectedField = event.field_id;
      } else {
        this.selectedField = this.options.filter(item =>
          item.name === textOutsideSpan || item.labelShort === textOutsideSpan
        )[0]?.field_id;
      }
    }
    this.selectedOptionChange.emit(event);
    this.rawSelectedName = event?.name || event?.type;
    if(this.config.tab == 'quick-insights') {
      this.selectedField = event.field_id;
      this.rawSelectedName = this.getPrefix(event.preffix) + event.name;
    }
    this.hideTooltip();
  }

  handleClickOutside = (event: MouseEvent) => {
    const dropdown = this.dropdownContainer.nativeElement;
    if (dropdown && !dropdown.contains(event.target as Node)) {
      this.isDropdownOpen = false;
      document.removeEventListener('click', this.handleClickOutside);
    }
  };

  getCategories(): any[] {
    const categories = this.options.map(option => option.category).filter(Boolean);
    const uniqueCategories = ['Others', ...new Set(categories)];
    return uniqueCategories;
  }

  getOptionsByCategory(category: string): any[] {
    if (category === 'Others') {
      return this.options.filter(option => !option.category);
    }
    return this.options.filter(option => option.category === category);
  }

  tooltipText: string = '';
  tooltipPosition = { top: 0, left: 0 };
  tooltipVisible: boolean = false;

  showTooltip(event: MouseEvent, option: any) {
    this.tooltipText = option.name ? option.name : option.text;
    this.tooltipPosition = { 
        top: event.clientY - 300,
        left: event.clientX - 130 
    };
    this.tooltipVisible = true;
}

  hideTooltip() {
    this.tooltipVisible = false;
  }
  getPrefix(prefix) {
    if(prefix != undefined || prefix != '') {
      return prefix.toLowerCase()
    }
  }
  showTitle(option) {
    if(this.config.tab === 'quick-insights') {
      return option.name? option.preffix + option.name: '';
    }else {
      return option.name? option.name: option.text;
    }
  }

  /** Short label in list/button when labelShort is set; full text via [attr.title] / showTitle */
  displayLabel(option: any): string {
    if (!option) return '';
    const full = option.name ?? option.text ?? '';
    return option.labelShort ?? full;
  }
  ngOnDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  }
}